import Button from "@/common/components/Button";
import { ShowHeader } from "@/common/components/ShowHeader";
import { useGoBack } from "@/common/hooks/useGoBack";
import { maintenanceForwardingsDirectiveEntryKlasses } from "@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.constant";
import { useMaintenanceWorkflow } from "@/features/maintenanceWorkflow/pages/Create/hooks/useMaintenanceWorkflow";
import { ChevronsRightIcon } from "lucide-react";
import { useParams } from "react-router-dom";

interface MaintenanceEstablishmentChoiceEntryAuctionHeaderProps {
  actions?: JSX.Element;
  showCancelButton?: boolean;
}

const MaintenanceEstablishmentChoiceEntryAuctionHeader = ({
  actions,
  showCancelButton,
}: MaintenanceEstablishmentChoiceEntryAuctionHeaderProps) => {
  const { id: workflowId, directiveEntryType } = useParams();

  const goBack = useGoBack();

  const { data: workflow, isPending: workflowIsPending } = useMaintenanceWorkflow(workflowId);

  return (
    <ShowHeader
      goBack
      goBackProps={{
        fallback: `/maintenance-workflows/${workflowId}/${directiveEntryType}`,
        searchLastRouteFromFallback: true,
      }}
      isLoading={!!workflowIsPending}
      title="Processos de manutenção"
      subtitle={
        <div className="flex items-center gap-2">
          <p>{workflow?.protocol_number || ''}</p>

          <ChevronsRightIcon />

          <p className="text-white-800">
            Leilão {directiveEntryType
              ? `(${maintenanceForwardingsDirectiveEntryKlasses[directiveEntryType as keyof typeof maintenanceForwardingsDirectiveEntryKlasses]?.label})`
              : ''}
          </p>
        </div>
      }
      titleClassName="text-md"
      className="text-white-400"
      subtitleClassName="text-nowrap font-medium"
      buttons={
        <div className="flex items-center gap-3">
          {showCancelButton && (
            <Button
              variant="outline-error"
              onClick={() =>
                goBack({
                  fallback: `/maintenance-workflows/${workflowId}/${directiveEntryType}`,
                  searchLastRouteFromFallback: true,
                })
              }
            >
              Cancelar
            </Button>
          )}

          {actions}
        </div>
      }
    />
  );
}

export default MaintenanceEstablishmentChoiceEntryAuctionHeader;
